export enum NavigationItems {
  intro = 'intro',
  about = 'about',
  benefits = 'benefits',
  // contributors = 'contributors',
  patai = 'patai',
}
